// extracted by mini-css-extract-plugin
module.exports = {"head":"_3tMhj2P9gPH6YDKV5joSrN","careerSection":"A2vo9VupzIR3ptaILubrt"};